import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import Logo from '../assets/images/Agilus---Logo.png'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <section className='footer bg-black custom-rounded custom-rounded-wrapper mx-5 my-4 archivo-normal'>
        <Container className='text-white custom-rounded p-5'>
            <Row>
                <Col sm={5}>
                    <img src={Logo} className='img-fluid w-35 mb-3'/>
                    {/* <p className='footer-color'>Automating Networks: Efficiency, Scalability, and Innovation at Every Step.</p> */}
                    
                </Col>
                <Col sm={3}>
                    <h4 className='mb-4 footer-color font-18'>Platforms</h4>
                    <ul>
                        <li><Link to={'/compliance-engine'} className='font-14'>Network Compliance Platform</Link> </li>
                        <li><Link to={'/bullseye'} className='font-14'>BullsEye</Link> </li>
                        <li><Link to={'/observer'} className='font-14'>The Observer</Link> </li>
                        <li><Link to={'/vAutomate'} className='font-14'>vAutomate</Link> </li>
                        
                    </ul>
                </Col>
                <Col sm={2}>
                    <h4 className='mb-4 footer-color font-18'>Company</h4>
                    <ul>
                        {/* <li><Link to={'/'} className='font-14'>Our Team</Link> </li>
                        <li><Link to={'/'} className='font-14'>Award & Recognition</Link> </li>
                        <li><Link to={'/'} className='font-14'>Our Partner</Link> </li>
                        <li><Link to={'/'} className='font-14'>Press Release</Link> </li> */}
                        <li><Link to={'/about'} className='font-14'>About Us</Link> </li>
                        <li><Link to={'/meet-expert'} className='font-14'>Leadership Team</Link> </li>
                    </ul>
                </Col>
                
                <Col sm={2}>
                    <h4 className='mb-4 footer-color font-18'>Contact</h4>
                    <ul>
                        {/* <li><Link to={'/'} className='font-14'>Career</Link> </li> */}
                        <li><Link to={'/termofuse'} className='font-14'>Term of Use</Link> </li>
                        {/* <li><Link to={'/'} className='font-14'>Extended Producer
                        Responsibilities</Link> </li> */}
                        {/* <li><Link to={'/'} className='font-14'>Vendor Registration</Link> </li> */}
                    </ul>
                </Col>
                <Col sm={6}>
                <div className='social-icon'>
                    <a href='https://www.linkedin.com/company/agilus-technologies/'>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#fff" class="bi bi-linkedin" viewBox="0 0 16 16">
  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
</svg>
</a>
                    </div></Col>
                <Col sm={12}>
                <hr />
                    <p className='font-14 fw-normal text-center  footer-color '>Copyright © {new Date().getFullYear()} Agilus Technologies Pvt. Ltd.</p>
                </Col>
            </Row>
        </Container>
    </section>
  )
}
